<template>
  <div
    v-if="data && data.requester"
    class="napaItem"
    style="display: flex; align-items: center; "
  >
    <figure class="napaItemImage">
      <img
        :src="
          getAvatarLink(
            data.requester.avatar,
            getDefaultAvatar(data.requester.roleName),
          )
        "
        alt=""
      />
    </figure>
    <div class="napaItemText">
      <div>
        <h6 class="napaItemTitle">
          {{ data.requester.company }}
        </h6>
        <h3
          class="napaItemDesc"
          style="display: flex; align-items: center; flex-wrap: wrap;"
        >
          {{ data.requester.name }}
          <span
            v-if="isUser && data.requester.classification"
            :style="{
              'background-color': chipColor(data.requester.classification),
            }"
            class="chip-user"
          >
            {{ chipText(data.requester.classification) }}
          </span>
        </h3>
        <h6 class="napaItemTime">{{ time }}</h6>
      </div>
      <MainBadge
        :title="getBtnLabel(data.status)"
        :variant="getBadgeVariant(data.status)"
      />
    </div>

    <div>
      <MainButton
        size="large"
        btnText="신청서 보기"
        color="primary"
        @click="(e) => handleClickItem(data)"
      />
      <button
        class="btn-outlined"
        @click="(e) => handleClickItemButtonDelete(data)"
      >
        삭제하기
      </button>
    </div>
  </div>
</template>
<script>
import MainButton from "@/components/button/MainButton.vue";
import MainBadge from "@/components/badge/MainBadge.vue";
import matchingColorMixins from "@/mixins/matching-color-mixins";
import { ROLE } from "@/data/role";
import moment from "moment";

export default {
  name: "ItemReceived",
  mixins: [matchingColorMixins],
  props: {
    data: {},
    handleClickItem: {
      type: Function,
      default: () => () => {},
    },
    handleClickItemButtonDelete: {
      type: Function,
      default: () => () => {},
    },
  },
  computed: {
    isUser() {
      return this.data?.requester?.roleName == ROLE.USER;
    },
    time() {
      return moment(this.data?.submittedTime).format("YYYY.MM.DD A hh:mm");
    },
  },
  data() {
    return {};
  },
  components: { MainBadge, MainButton },
};
</script>
<style lang="scss" scoped>
// Section 2

.btn-outlined {
  height: 48px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 2.1rem;
  margin-top: 16px;
  cursor: pointer;
}

.chip-user {
  font-size: 1.4rem;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  margin-left: 4px;
}
</style>
